import CertificateComponent from './component'
export default CertificateComponent
